import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './PasswordResetEmailSent.scss';
import NeedHelp from 'components/needHelp/NeedHelp';
import { showErrorNotification } from 'utils/commonUtils';
import CarouselContainer from 'components/carouselContainer/CarouselContainer';
import { requestResetPassword } from 'services/loginService';
// import { useSession } from 'context/SessionContext';
// import { SessionDTO } from 'types/dto/login';
import { useLocation } from 'react-router-dom';
// import { MemberProfile } from 'types/dto/profile';

// Email desensitization function
const maskEmail = (email: string): string => {
  if (!email) return email;
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email;

  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex);


  const maskedLocal = localPart[0] + '***' + localPart.slice(-1);
  return maskedLocal + domain;
};

const PasswordResetEmailSent: React.FC = () => {
  const { t } = useTranslation('password_reset_email_sent');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);
  // const { session, setSession } = useSession();
  // const { profile } = useOutletContext<{ profile: MemberProfile | null }>();
  // const email = profile?.email || '';
  const location = useLocation();
  const email = location.state?.email;


  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);

  const handleResendEmail = async () => {
    if (countdown > 0 || loading) return;

    try {
      setLoading(true);
      await requestResetPassword();

      // setSession({
      //   ...session,
      //   _ml: response.email,
      // } as SessionDTO);

      setCountdown(60);
    } catch (error) {
      showErrorNotification(t('resendFailed'), error as Error);
    } finally {
      setLoading(false);
    }
  };

  const maskedEmail = maskEmail(email);

  return (
    <CarouselContainer>
      <div className="password-reset-email-sent-form-container">
        <div className="password-reset-email-sent-form-section">
          <div className="password-reset-email-sent-title">{t('title')}</div>

          <div className="password-reset-email-sent-subtitle">
            {t('resetPasswordSubtitle', { email: maskedEmail })}
          </div>

          <div>
            <div className="password-reset-email-sent-prompt">{t('notReceiving')}</div>

            <Button
              type="default"
              block
              onClick={handleResendEmail}
              disabled={countdown > 0}
              loading={loading}
              color="primary"
              variant="outlined"
              className="resend-button"
            >
              {countdown > 0
                ? t('resendIn', { seconds: countdown })
                : t('resendButton')}
            </Button>
          </div>

          <NeedHelp />
        </div>
      </div>
    </CarouselContainer>
  );
};

export default PasswordResetEmailSent;